<template>
  <b-overlay :show="loadingAction">
    <b-dropdown
      v-if="selectedBatches.length > 1"
      variant="link"
      no-caret
      v-has-permission="'ED185'"
      data-cy="massive-actions"
      right
    >
      <template #button-content>
        <feather-icon
          icon="ApertureIcon"
          class="mr-3"
        />
        <span class="align-middle">Acciones</span>
      </template>
      <CheckPermission permission="ED172">
        <b-dropdown-item
          v-on:click="onOptionBatchCancel()"
          data-cy="massive-cancel"
        >
          <vs-icon icon="highlight_off"/>
          Anular
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED169">
        <b-dropdown-item
          v-on:click="onOptionBatchValidate()"
          data-cy="massive-validate"
        >
          <vs-icon icon="verified_user"/>
          Validar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED167">
        <b-dropdown-item
          v-on:click="onOptionBatchApprove()"
          data-cy="massive-approve"
        >
          <vs-icon icon="thumb_up"/>
          Aprobar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED186">
        <b-dropdown-item
          v-on:click="onOptionBatchReject()"
          data-cy="massive-reject"
        >
          <vs-icon icon="thumb_down"/>
          Rechazar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED173">
        <b-dropdown-item
          v-on:click="onOptionBatchPostule"
          data-cy="massive-add-auction"
        >
          <vs-icon
            icon="add_circle"
          />
          Agregar a subasta
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED225">
        <b-dropdown-item
          v-on:click="onOptionBatchDonate()"
          data-cy="massive-donate"
        >
          <vs-icon icon="store"/>
          Donar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED226">
        <b-dropdown-item
          v-on:click="onOptionBatchDestroy()"
          data-cy="massive-destroy"
        >
          <vs-icon icon="delete"/>
          Destruir
        </b-dropdown-item>
      </CheckPermission>
      <b-modal
        id="batches-cancel"
        ref="batches-cancel"
        :title="`Anular Lotes`"
        hide-footer
      >
        <BatchesCancel
          :batches="selectedBatches"
          @cancel="handleOnCancel"
        />
      </b-modal>
      <b-modal
        id="batches-reject"
        ref="batches-reject"
        :title="`Rechazar Lotes`"
        hide-footer
      >
        <BatchesReject
          :batches="selectedBatches"
          @reject="handleOnReject"
        />
      </b-modal>
      <b-modal
        id="batches-approve"
        ref="batches-approve"
        :title="`Aprobar Lotes`"
        hide-footer
      >
        <BatchesApprove
          :batches="selectedBatches"
          @approve="handleOnApprove"
        />
      </b-modal>
      <b-modal
        id="batches-postule"
        ref="batches-postule"
        :title="`Agregar ${selectedBatchesIds.length} Lotes a Subasta`"
        no-close-on-backdrop
        size="xl"
        hide-footer
      >
        <BatchPostule
          :batch-ids="selectedBatchesIds"
          @postule="handleOnPostule"
        />
      </b-modal>
    </b-dropdown>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import {
  BatchesApprove,
  BatchesCancel,
  BatchPostule,
  BatchesReject
} from '@/febos/aduanas/batches/views/components/modals';
import {
  batchesStates,
  CANCEL_STATES,
  POSTULE_STATES,
  APPROVE_STATES,
  VALIDATE_STATES, REJECT_STATES, RETURN_STATES
} from '@/febos/aduanas/batches/views/utils/constants';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import {
  LLAMADA_MASIVA_ADUANA_VALIDAR_LOTE_BASE,
  LLAMADA_MASIVA_ADUANA_DONAR_LOTE_BASE, LLAMADA_MASIVA_ADUANA_DESTRUIR_LOTE_BASE
} from '@/febos/servicios/api/aduanas/constantes';
import MasivasMixin from '@/febos/global/_vue/mixins/MasivasMixin';
import { auctionsStateCode } from '@/febos/aduanas/auctions/views/utils/constants';

export default {
  components: {
    CheckPermission,
    BatchesCancel,
    BatchPostule,
    BatchesApprove,
    BatchesReject
  },
  mixins: [MasivasMixin],
  props: [
    'selectedBatches'
  ],
  data() {
    return {
      auctionsStateCode,
      loadingAction: false,
      POSTULE_STATES,
      CANCEL_STATES,
      RETURN_STATES,
      APPROVE_STATES,
      VALIDATE_STATES,
      loading: false
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    selectedBatchesIds() {
      return this.selectedBatches.map((batch) => batch.loteId);
    },
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    checkAllBatchInStates(states) {
      return this.selectedBatches.every((batch) => states.includes(batch.estado));
    },
    canDonate() {
      return this.selectedBatches.every((batch) => RETURN_STATES.includes(batch.estado)
        && batch.subasta.estado === auctionsStateCode.finalizada
        && batch.subastasCantidad >= 4 && batch.devolucionesCantidad === 3);
    },
    async updateBatch(request) {
      const payload = {
        ...request,
        ...{
          comunes: {
            ...request.comunes
          },
          payload: this.selectedBatches.map(
            (batch) => ({
              lote_id: batch.loteId
            })
          )
        }
      };
      this.loadingAction = true;
      try {
        await this.sendMasiveProcess(payload);
        this.$vs.notify({
          title: 'Genial!',
          text: `Se ha solicitado la actualización de ${this.selectedBatches.length} lotes,
          te enviaremos un correo con los detalles cuando esta termine.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
        this.loadingAction = false;
      } finally {
        this.loadingAction = false;
      }
    },
    onOptionUpdateBatch(request, action) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas enviar a ${action} ${this.selectedBatches.length} lotes?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateBatch(request)
      });
    },
    onOptionBatchValidate() {
      const allInStateToCancel = this.checkAllBatchInStates(VALIDATE_STATES);
      if (allInStateToCancel) {
        this.onOptionUpdateBatch(LLAMADA_MASIVA_ADUANA_VALIDAR_LOTE_BASE, 'revisión');
      } else {
        const statusNames = VALIDATE_STATES.map((state) => batchesStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden validar lotes en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionBatchDonate() {
      const canDonate = this.canDonate();
      if (canDonate) {
        this.onOptionUpdateBatch(LLAMADA_MASIVA_ADUANA_DONAR_LOTE_BASE, 'donar');
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'No se puede realizar la donación de todos los lotes seleccionados',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionBatchDestroy() {
      const canDonate = this.canDonate();
      if (canDonate) {
        this.onOptionUpdateBatch(LLAMADA_MASIVA_ADUANA_DESTRUIR_LOTE_BASE, 'la acción destruir');
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'No se puede realizar la destrucción de todos los lotes seleccionados',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionBatchCancel() {
      const allInStateToCancel = this.checkAllBatchInStates(CANCEL_STATES);
      if (allInStateToCancel) {
        this.$refs['batches-cancel'].show();
      } else {
        const statusNames = CANCEL_STATES.map((state) => batchesStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden anular lotes en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionBatchReject() {
      const allInStateToReject = this.checkAllBatchInStates(REJECT_STATES);
      if (allInStateToReject) {
        this.$refs['batches-reject'].show();
      } else {
        const statusNames = REJECT_STATES.map((state) => batchesStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden rechazar lotes en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionBatchApprove() {
      const allInStateToApprove = this.checkAllBatchInStates(APPROVE_STATES);
      if (allInStateToApprove) {
        this.$refs['batches-approve'].show();
      } else {
        const statusNames = APPROVE_STATES.map((state) => batchesStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Solo se pueden aprobar lotes en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionBatchPostule() {
      const allInStateToPostule = this.checkAllBatchInStates(POSTULE_STATES);
      if (allInStateToPostule) {
        this.$refs['batches-postule'].show();
      } else {
        const statusNames = POSTULE_STATES.map((state) => batchesStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Solo se pueden agregar lotes en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    handleOnCancel() {
      this.$refs['batches-cancel'].hide();
      this.$emit('reload-list');
    },
    handleOnReject() {
      this.$refs['batches-reject'].hide();
      this.$emit('reload-list');
    },
    handleOnApprove() {
      this.$refs['batches-approve'].hide();
      this.$emit('reload-list');
    },
    handleOnPostule() {
      this.$refs['batches-postule'].hide();
      this.$emit('reload-list');
    }
  }
};

</script>
